import { useBillingQueryContext } from 'modules/dataWarehouse/contexts/BillingQueryContext';
import { ModalAction } from 'modules/dataWarehouse/types';
import { shouldRestrictCreation } from 'modules/dataWarehouse/utils';
import styled from 'styled-components';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { Body2, colors, spacing } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';

const StyledZeroState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.double};
  background-color: ${colors.backgroundSecondary};
  border-radius: 0 0 ${spacing.half} ${spacing.half};
`;

const StyledBodyText = styled(Body2)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.textSecondary};
`;

export const ZERO_MESSAGE_TEXT = {
  action: 'Create a new sync to start importing your data.',
  buttonText: 'New sync',
  description: "Your source is connected, but you haven't set up a sync yet.",
};

export const ZeroStateMessage = ({ sourceId }: { sourceId: number }) => {
  const { showModal } = useModalContext();
  const { currentProjectStatus, remainingSyncs } = useBillingQueryContext();

  const handleAdd = () => {
    const shouldRestrict = shouldRestrictCreation(currentProjectStatus, remainingSyncs);
    const action = shouldRestrict ? ModalAction.RESTRICT_CREATE : ModalAction.CREATE_SYNC;
    showModal({ action, payload: { sourceId } });
  };

  return (
    <StyledZeroState>
      <StyledBodyText>
        <span>{ZERO_MESSAGE_TEXT.description}</span>
        <span>{ZERO_MESSAGE_TEXT.action}</span>
      </StyledBodyText>
      <SecondaryButton onClick={handleAdd} size={BUTTON_SIZES.MEDIUM}>
        <Add16 />
        <span>{ZERO_MESSAGE_TEXT.buttonText}</span>
      </SecondaryButton>
    </StyledZeroState>
  );
};
